import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['message', _vm.sent ? 'send' : 'receive']},[_c('div',{staticClass:"message-bubble-content",staticStyle:{"width":"200px"}},[_c(VSkeletonLoader,{attrs:{"type":("" + _vm.loaderType)}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }